
module.exports.userJustManager = (claims)=>{
return !claims.isAdmin && !claims.isSuperAdmin && claims.isManager 
} 

const CHARACTER_SETS = {
    UPPER: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    LOWER: 'abcdefghijklmnopqrstuvwxyz',
    NUMBERS: '0123456789',
    SPECIAL: '!@#$%^&*'
};

module.exports.generatePassword = () => {
    const sets = {
      upper: CHARACTER_SETS.UPPER,
      lower: CHARACTER_SETS.LOWER,
      num: CHARACTER_SETS.NUMBERS,
      special: CHARACTER_SETS.SPECIAL
    };
    
    // Get one from each set
    const required = Object.values(sets).map(set => 
      set[crypto.getRandomValues(new Uint8Array(1))[0] % set.length]
    ).join('');
    
    // Fill rest with random chars from all sets
    const all = Object.values(sets).join('');
    const rest = Array.from(crypto.getRandomValues(new Uint8Array(8)))
      .map(b => all[b % all.length])
      .join('');
  
    // Shuffle and return
    return (required + rest)
      .split('')
      .sort(() => crypto.getRandomValues(new Uint8Array(1))[0] - 127)
      .join('');
}